import { useState } from "react";
import { TranslationService } from "../../../../../services/TranslationService";
import CompanyService from "../../../../../services/CompanyService";
import { ContactService } from "../../../../../services/ContactService";
import { formatNumberFractions } from "../../../../../utils/FormatUtils";
import { handleErrorWithToast } from "../../../../../utils/RequestUtils";
import ModalService from "../../../../shared/bootstrap/modal/Modal";
import { ToastService } from "../../../../shared/bootstrap/Toast";
import Label from "../../../../shared/form/Label";
import {
  RequiredManager,
  ValidationMessage
} from "../../../../shared/RequieredManager";
import {
  TextEditorNumber,
  parseToNumber
} from "../../../../shared/components/Editors";

export const AIBillingRequestBalanceForm = () => {
  const { translate } = TranslationService;
  const token = CompanyService.getCompanyToken()!;
  const currencySymbol = CompanyService.GetDefaultCurrencySymbol();
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");

  const requiredManager = new RequiredManager();
  const changeAmount = requiredManager.makeRequiredWithId(
    (value: string) => setAmount(value),
    "amount"
  );

  const buildMessage = (amountNumber: number) =>
    [
      translate.AIRequestBalanceInfo,
      `${translate.AIRequestedAmount}: ${currencySymbol} ${formatNumberFractions(amountNumber, 2)}`
    ].join("\n\n");

  const onSubmit = async () => {
    if (!requiredManager.validate()) {
      return;
    }
    setLoading(true);
    try {
      const amountNumber = parseToNumber(amount) ?? 0;
      await handleErrorWithToast(
        ContactService.sendMessage({
          name: `${token.firstname} ${token.lastname}`,
          email: token.emailaddress,
          company: CompanyService.getCompanyAuth()!.companyName,
          message: buildMessage(amountNumber),
          phone: "",
          country: ""
        })
      );
    } catch {
      return;
    } finally {
      setLoading(false);
    }

    ToastService.showToast(
      translate.AIRequestBalanceSentMessage,
      translate.AIRequestBalanceSentTitle,
      "success"
    );
    ModalService.hideModal();
  };

  return (
    <>
      <div>
        <p className="mb-3">{translate.AIRequestBalanceInfo}</p>
        <Label className="w-100" label={translate.AIRequestedAmount}>
          <TextEditorNumber
            id="amount"
            placeholder={translate.AIRequestedAmount}
            defaultValue={amount}
            onChange={changeAmount}
            withBox
            boxLeft
            boxText={currencySymbol}
          />
          <ValidationMessage
            defaultValue={amount}
            onChange={requiredManager.getValidation("amount")}
            validationMethod={(value) => (parseToNumber(value) ?? 0) > 0}
          />
        </Label>
      </div>
      <div className="modal-footer pb-0 pe-0">
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {translate.Close}
        </button>
        <button
          type="button"
          onClick={() => onSubmit()}
          className="btn btn-primary"
        >
          {translate.AIRequestBalance}
          {loading && (
            <i className="fas fa-spinner-third fa-spin third ms-2"></i>
          )}
        </button>
      </div>
    </>
  );
};

export function showAIBillingRequestBalanceModal(): void {
  ModalService.showDefaultModal({
    title: TranslationService.translate.AIRequestBalanceTitle,
    hideClose: true,
    size: "modal-lg",
    message: AIBillingRequestBalanceForm
  });
}
